import {
  getMetaDescriptionFromMemberData,
  getQueryPrefixes,
  parseUrl,
} from './utils';
import {
  getPathnameAndHashFromHref,
  removeTrailingSlashes,
} from '../locationUtils';
import { getLinkToMixedInFrom, getTextFromDesc } from '../flattenTree/utils';
import { removeMarkdownFromText } from '../markdownUtils';
import { TYPES } from '../flattenTree/utils/consts';
import { getNodeByLink } from '../../Store/Utils/treeUtils';

const getDescriptionOfMember = (pathname: string, fullTree: any = {}) => {
  const link = removeTrailingSlashes(pathname).split('?')[0];
  const node = getNodeByLink(fullTree, link);
  if (node?.data) {
    try {
      const description = node.data?.docs?.description
        ? removeMarkdownFromText(getTextFromDesc(node.data?.docs?.description))
        : '';

      const summary =
        node.data.propType === TYPES.MD
          ? removeMarkdownFromText(node.data?.content)
          : removeMarkdownFromText(node.data?.docs?.summary);

      return getMetaDescriptionFromMemberData(summary, description);
    } catch (err) {
      console.error(
        'error while creating the page meta description (description of member)::',
        link,
        err,
      );
    }
  }
  return '';
};

export const SEOUtils = (
  { pathname, basename, host },
  seoConfig,
  fullTree = {},
) => {
  const basenameWithoutTrailingSlash = removeTrailingSlashes(basename);
  const pathnameWithoutUrlPath = pathname.replace(
    basenameWithoutTrailingSlash,
    '',
  );
  const isHomePage =
    pathnameWithoutUrlPath === '' || pathnameWithoutUrlPath === '/';

  // calculate title
  const title = isHomePage
    ? seoConfig.homePageTitle || seoConfig.pageTitleSuffix
    : pageTitle(pathnameWithoutUrlPath, seoConfig.pageTitleSuffix, fullTree);

  // calculate description
  const description = isHomePage
    ? seoConfig.homePageDescription
    : getDescriptionOfMember(pathnameWithoutUrlPath, fullTree);

  // calculate canonical link
  const canonicalLink = getCanonicalLink(
    host,
    basenameWithoutTrailingSlash,
    pathnameWithoutUrlPath,
    fullTree,
  );

  return { title, description, canonicalLink };
};

function pageTitle(pathname, pageTitleSuffix, fullTree = {}) {
  const link = removeTrailingSlashes(pathname).split('?')[0];
  const node = getNodeByLink(fullTree, link);
  if (node?.data) {
    try {
      const { name, displayName } = node.data;
      const [, query] = parseUrl(pathname);
      const prefix = getQueryPrefixes(query);
      return `${prefix}${displayName || name}${
        pageTitleSuffix ? ` ${pageTitleSuffix}` : ''
      }`;
    } catch (err) {
      console.error('error while creating the page title::', link, err);
    }
  }
  if (isMenuEditor(pathname)) {
    return `Menu Editor ${pageTitleSuffix}`;
  }
  return `Page Not Found ${pageTitleSuffix}`;
}

function getCanonicalLink(host, basename, pathname, fullTree = {}) {
  const link = removeTrailingSlashes(pathname).split('?')[0];
  const node = getNodeByLink(fullTree, link);
  if (node?.data) {
    const originalMixedInFromLink = getLinkToMixedInFrom(
      node.data?.mixedInFrom?.original,
    );

    if (originalMixedInFromLink) {
      const canonicalLinkPathname = `${originalMixedInFromLink}/${node.data.urlFormat}`;
      return `https://${host}${basename}${canonicalLinkPathname}`;
    }
  }
  return `https://${host}${basename}${pathname}`;
}

function isMenuEditor(url = '') {
  const pathnameWithSearch = getPathnameAndHashFromHref(url)[0];
  const pathname = pathnameWithSearch.split('?')[0];
  return pathname.endsWith('/menu-editor');
}
